import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';
import { createDefaultGameProgress } from '@lib/tools/gamification/slices';
import type { TGameProgress } from '@lib/tools/gamification/types';

const selectGamificationState = (state: AppStateType) => state.gamification;

export const selectIsGameInitializing = createSelector([selectGamificationState], state => state.isGameInitializing);

export const selectIsGameProgressUpdating = createSelector(
  [selectGamificationState],
  state => state.isGameProgressUpdating,
);

export const selectGamificationProducts = createSelector([selectGamificationState], state => state.products);

export const selectUsedGamificationProducts = createSelector([selectGamificationState], state => state.usedProducts);

export const selectGameDetails = createSelector([selectGamificationState], state => state.gameDetails);

export const selectGameEnrollments = createSelector([selectGamificationState], state => state.gameEnrollments);

export const selectGameTotalScore = createSelector(
  [selectGamificationState],
  state => state.gameEnrollments?.totalScore ?? 0,
);

export const selectGamesProgress = createSelector([selectGamificationState], state => state.gamesProgress);

export const selectLeaderboardConfirmationByGame = createSelector(
  [selectGamificationState],
  state => state.leaderboardConfirmationByGame,
);

export const selectSurveyGame = createSelector([selectGamificationState], state => state.surveyGame);

export const selectCurrentGameProgress = createSelector(
  [selectGamesProgress, selectGameDetails],
  (gamesProgress, gameDetails): TGameProgress =>
    (gameDetails ? gamesProgress[gameDetails.slug] : undefined) ?? createDefaultGameProgress(),
);

export const selectIsLeaderboardConfirmationAccepted = createSelector(
  [selectLeaderboardConfirmationByGame, selectGameDetails],
  (leaderboardConfirmationByGame, gameDetails) =>
    Boolean(gameDetails?.slug && leaderboardConfirmationByGame[gameDetails.slug]),
);
